import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=40cb81d5&scoped=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb81d5",
  null
  
)

export default component.exports